
//#region Imports
//#region Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

//#endregion

//#region Bootstrap

import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import {
    BsDatepickerModule,
    BsDatepickerConfig,
    BsDaterangepickerConfig,
    BsLocaleService
} from 'ngx-bootstrap/datepicker';

import { NgxBootstrapDatePickerConfigService } from '@axilla/axilla-shared';

//#endregion

//#region Primeng
import { TableModule } from 'primeng/table';
import { DataViewModule } from 'primeng/dataview';
import { TreeModule } from 'primeng/tree';
import { DragDropModule } from 'primeng/dragdrop';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CarouselModule } from 'primeng/carousel';
import { SpinnerModule } from 'primeng/spinner';
import { PanelModule } from 'primeng/panel';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { RatingModule } from 'primeng/rating';
import { DropdownModule } from 'primeng/dropdown';
//#endregion


//#region Custom

import { MasterCommonModule, AxillaCommonModule } from '@axilla/axilla-shared';

//#region Modules
import { WebshopUtilsModule } from '@shared/utils/utils.module';
import { UblCommonModule } from './common/common.module';

//#endregion

//#region Components
import { SearchAndSelectArticlesComponent } from './articles/search-and-select-articles.component';
import { SearchAndSelectCustomersComponent } from './customers/search-and-select-customers.component';
import { SearchAndSelectUserGroupsComponent } from './search-and-select-user-groups/search-and-select-user-groups.component';
//#endregion

//#region Services
import { TypeHelperService } from './services/type-helper.service';
import { CountryHelperService } from './services/country-helper.service';
import { SmallPalletDetailsComponent } from './pallet/small-pallet-details.component';
import { PalletDetailsComponent } from './pallet/pallet-details.component';
import { PalletsComponent } from './pallet/pallets.component';
import {QuickAddComponent} from '@app/shared/common/shop-system/common/quick-add/quick-add.component';

//#endregion

//#endregion

//#endregion

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        ModalModule.forRoot(),
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TableModule,
        WebshopUtilsModule,
        DropdownModule,
        ButtonModule,
        PaginatorModule,
        AutoCompleteModule,
        ProgressSpinnerModule,
        UblCommonModule,
        AxillaCommonModule,
        MasterCommonModule
    ],
    declarations: [
        SearchAndSelectArticlesComponent,
        SearchAndSelectCustomersComponent,
        SearchAndSelectUserGroupsComponent,
        SmallPalletDetailsComponent,
        PalletDetailsComponent,
        PalletsComponent,
        QuickAddComponent
    ],
    exports: [
        SearchAndSelectArticlesComponent,
        SearchAndSelectCustomersComponent,
        SearchAndSelectUserGroupsComponent,
        SmallPalletDetailsComponent,
        PalletDetailsComponent,
        PalletsComponent,
        QuickAddComponent
    ],
    providers: [
        TypeHelperService,
        CountryHelperService,
        BsModalRef,
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale }
    ]
})
export class ShopSystemModule { }
